module.exports = __webpack_public_path__ + "img/logo-full-white.685e4694.png";